import {put, call} from "redux-saga/effects";
import {fromJS} from "immutable";

// API Calls
import {fetchGlobalSearch} from "../api/globalSearch";

// Actions
import {
	fetchGlobalSearchSuccess,
	fetchGlobalSearchError,
} from "../actions/actionCreators";

export function* fetchGlobalSearchSaga({payload}) {

	try {
		let result = yield call( ()=> fetchGlobalSearch(payload));
		yield put( fetchGlobalSearchSuccess( fromJS(result) ) );

	} catch (error) {
		yield put(fetchGlobalSearchError(error));
	}

}



// WEBPACK FOOTER //
// ./src/js/sagas/globalSearchSaga.js